import { httpClient } from '@/infra/protocols/http';
import { IProjectDTO } from '@/modules/projects/dtos/project.dto';
import { IProject } from '@/modules/projects/entities/project.entity';
import { ProjectMapper } from '@/modules/projects/mappers/project.mapper';

export async function createProject(
  data: CreateProjectService.Payload,
): Promise<CreateProjectService.Response> {
  const body = {
    nome: data.name,
    imagem: data.fileName,
    descricao: data.description,
  };

  const response = await httpClient.post<IProjectDTO>(`/v1/projetos`, body);

  return ProjectMapper.toPresentation(response);
}

export namespace CreateProjectService {
  export interface Payload {
    name: string;
    fileName?: string;
    description: string;
  }

  export type Response = IProject;
}
